import React, { useState } from 'react';
import Papa from 'papaparse';
import { addProductToStore } from '../Api';
import { toast } from 'react-toastify';
import { Modal, Button, Upload, Typography } from 'antd';

const { Title, Text } = Typography;

const CsvProductUploader = () => {
    const [open, setOpen] = useState(false);
    const [csvFile, setCsvFile] = useState(null);
    const [isUploading, setIsUploading] = useState(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => {
        setCsvFile(null);
        setOpen(false);
    };

    const handleFileChange = (event) => {
        setCsvFile(event.target.files[0]);
    };

    const handleUpload = () => {
        if (!csvFile) {
            toast.warn('Please select a CSV file.');
            return;
        }

        setIsUploading(true);

        Papa.parse(csvFile, {
            header: true,
            skipEmptyLines: true,
            complete: async (result) => {
                const products = result.data;

                for (const product of products) {
                    const productData = {
                        name: product.name,
                        type: product.type || 'simple',
                        sku: product.sku,
                        regular_price: product.regular_price?.toString() || '0',
                        description: product.description || '',
                        categories: product.categories ? [{ name: product.categories }] : [],
                        images: product.image_url ? [{ src: product.image_url }] : [],
                    };

                    try {
                        await addProductToStore(productData);
                        console.log(`✅ Product added: ${product.name}`);
                    } catch (err) {
                        console.error(`❌ Error adding ${product.name}:`, err.message);
                    }
                }

                toast.success('CSV upload complete!');
                setIsUploading(false);
                handleClose();

                // ✅ reload after all uploads are done
                window.location.reload();
            },
        });
    };

    return (
        <>
            <button
                style={{
                    height: 35,
                    width: "100%",
                    border: "none",
                    background: "#0165AB",
                    color: "#fff",
                    borderRadius: 5,
                    cursor: "pointer",
                }}
                onClick={handleOpen}
            >
                UPLOAD CSV
            </button>

            <Modal
                title="Upload Products CSV"
                open={open}
                onCancel={handleClose}
                footer={[
                    <Button key="cancel" onClick={handleClose}>
                        Cancel
                    </Button>,
                    <Button
                        key="upload"
                        type="primary"
                        loading={isUploading}
                        onClick={handleUpload}
                    >
                        Upload
                    </Button>,
                ]}
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                    <Text>Choose a `.csv` file containing product details:</Text>
                    <input type="file" accept=".csv" onChange={handleFileChange} />
                    {csvFile && (
                        <Text type="secondary">Selected File: {csvFile.name}</Text>
                    )}
                </div>
            </Modal>
        </>
    );
};

export default CsvProductUploader;
